import { IconNode, LucideIcon, Icon as LucideIconIcon } from "lucide-react";

export type IconType = LucideIcon | IconNode;

interface IconProps {
  icon: IconType;
  className?: string;
}

function isLucideIcon(icon: IconType): icon is LucideIcon {
  return Object.keys(icon).includes("$$typeof");
}

export function Icon({ icon, className }: IconProps) {
  if (isLucideIcon(icon)) {
    const LucideIcon = icon as unknown as LucideIcon;
    return <LucideIcon className={className} />;
  }
  return <LucideIconIcon iconNode={icon as IconNode} className={className} />;
}
